import {
  U21Avatar,
  U21Chip,
  U21ChipProps,
  U21Skeleton,
} from 'app/shared/u21-ui/components';
import { useSelector } from 'react-redux';
import { selectHasReadAgentsPermissions } from 'app/modules/session/selectors';
import { ROUTES_MAP } from 'app/shared/utils/routes';
import { getAgentDisplayName } from 'app/modules/agents/utils';
import { useGetAgentShort } from 'app/modules/agents/queries/useGetAgentShort';
import { forwardRef } from 'react';

interface Props extends Omit<U21ChipProps, 'children' | 'icon' | 'id'> {
  id: number;
}

export const AgentChip = forwardRef<HTMLDivElement, Props>(
  (props: Props, ref) => {
    const { id, ...rest } = props;
    const hasReadAgentsPermission = useSelector(selectHasReadAgentsPermissions);
    const { data, isLoading } = useGetAgentShort(id);

    if (isLoading || !data) {
      return <U21Skeleton height={24} width={100} />;
    }
    return (
      <U21Chip
        icon={
          <U21Avatar
            name={getAgentDisplayName(data)}
            size="small"
            src={data.picture}
          />
        }
        onClick={
          hasReadAgentsPermission ? (e) => e.stopPropagation() : undefined
        }
        ref={ref}
        to={
          hasReadAgentsPermission
            ? ROUTES_MAP.agentsId.path.replace(':id', String(id))
            : undefined
        }
        {...rest}
      >
        {data.full_name}
      </U21Chip>
    );
  },
);
